import axios, { AxiosResponse } from 'axios';
import Bottleneck from 'bottleneck';

import { Target, TargetRequest, TrackableTargetsResponse } from './Target';
import { Refuel } from './Refuel';
import { MessageThread, MinimalTarget } from '@/generated/model';

type GenerateReply = {
  loginToken: string;
}

const limiter = new Bottleneck({
  minTime: 5,
  maxConcurrent: 1,
});

let controllerTracking: AbortController | undefined = undefined;

export async function tracking(targets: TargetRequest[], popupTargetId: number | undefined, pathLengthMinutes: number | undefined): Promise<AxiosResponse<Target[] | undefined>> {
  if (controllerTracking) {
    controllerTracking.abort();
  }
  controllerTracking = new AbortController();

  const baseUrl = '/api/v1.1/targets/positions/tracking';
  var queryString = '';
  if (popupTargetId && targets.find(t => t.targetId === popupTargetId) !== undefined) {
    queryString = `?popupTargetId=${popupTargetId}`;
    if (pathLengthMinutes !== undefined) {
      queryString+= `&pathLengthMinute=${pathLengthMinutes}`;
    }
  }

  return axios.post<Target[]>(baseUrl + queryString, targets, {
    signal: controllerTracking.signal,
  });
}

export async function abortTracking() {
  if (controllerTracking) {
    controllerTracking.abort();
    controllerTracking = undefined;
  }
  return;
}

let controllerTarget: AbortController | undefined = undefined;

export async function targetList(
  searchText: string | undefined,
  offset: number,
  limit: number
): Promise<AxiosResponse<MinimalTarget[] | undefined>> {

  const params = new URLSearchParams();
  params.append('offset', String(offset));
  params.append('limit', String(limit));
  if (searchText) {
    params.append("filter", searchText);
  }

  // FIXME kellene lassitas bele
  const url = `/api/v1.1/targets?${params.toString()}`;

  return limiter.schedule(() => axios.get<MinimalTarget[]>(url));
}

export async function allTrackableTargetList(
  searchText: string | undefined
): Promise<AxiosResponse<TrackableTargetsResponse | undefined>> {
  const params = new URLSearchParams();
  if (searchText) {
    params.append("filter", searchText);
  }
  const url = `/api/v1.1/targets/all/trackable?${params.toString()}`;

  if (controllerTarget) {
    controllerTarget.abort();
  }
  controllerTarget = new AbortController();

  return axios.get<TrackableTargetsResponse>(url, {
    signal: controllerTarget.signal,
  }).finally(() => {
    controllerTarget = undefined;
  });
}

export async function trackedTargetLimit(): Promise<AxiosResponse<number | undefined>> {
  const url = '/api/v1.1/targets/trackedTargetLimit';

  return axios.get<number>(url);
}

let controllerRefuels: AbortController | undefined = undefined;

export async function refuels(
  target: MinimalTarget,
  from: Date,
  to: Date,
) {
  if (controllerRefuels) {
    controllerRefuels.abort();
  }
  controllerRefuels = new AbortController();

  const fromTime = `${from.getTime()}000`;
  const toTime = `${to.getTime()}000`;
  const url = `/api/v1.1/targets/${target.id}/fuelfillings?fromTime=${fromTime}&toTime=${toTime}&offset=0&limit=1000`;
  return axios.get<Refuel[]>(url, { signal: controllerRefuels.signal });
}

export async function recentMessages() {
  const url = `/api/v1.1/messageThreads/recent?threadLimit=10&messagesByThreadLimit=1`;
  return axios.get<MessageThread[]>(url);
}

export async function chatMessages(name: string) {
  const url = `/api/v1.1/messageThreads/threadUser?name=${name}&messagesByThreadLimit=10`;
  return axios.get<MessageThread[]>(url);
}

export async function generate(
  targetId: number,
  fromTimeMicros: number,
  toTimeMicros: number,
  emailAddress: string | undefined,
) {
  const data = {
    targetId,
    fromTimeMicros,
    toTimeMicros,
    emailAddress,
    type: 'tracking',
  }

  const url = '/api/v1.1/urls/generate';
  const reply = await axios.post<GenerateReply>(url, data);
  return reply.data.loginToken;
}

